/**
 * Coup de pouce — Attendu 1047 « Connaître et utiliser les tables de
 * multiplication ».
 *
 * UNE SEULE aide, partagée par les quatre generator_keys (cadrage prof
 * 2026-09-07). Elle enseigne un GESTE, pas un fait : partir d'un produit
 * voisin qu'on connaît et ajouter ou retirer une fois le nombre. C'est le
 * point d'appui du cycle 2, et la représentation par l'aire du cycle 3
 * (reprise en 5e pour la distributivité). L'élève doit encore connaître
 * 7 × 7 et calculer 49 + 7 : l'aide ne donne rien à recopier.
 *
 * COUPLE SACRIFIÉ : 7 × 8 ne sort d'aucune carte, dans aucun ordre (sinon
 * l'aide afficherait « = 56 » à côté des choix). Invariant protégé par
 * src/generators/tests/cdp1047.self.test.js.
 *
 * Le texte vit dans la figure (même parti que 1046) : la fiche affiche les
 * lignes avant la figure, or ici c'est la figure qui explique. L'aria-label
 * reprend les phrases pour la synthèse vocale.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const BLEU_CLAIR = '#DBEAFE';
const ENCRE = '#1E293B';

const CELL = 28;
const X0 = 76;
const Y0 = 46;

/** Le rectangle 7 × 8 : carré 7 × 7 en bleu, huitième colonne en orange. */
const grille = () => {
    const parts = [];
    for (let r = 0; r < 7; r++) {
        for (let c = 0; c < 8; c++) {
            const orange = c === 7;
            parts.push(`<rect x="${X0 + c * CELL}" y="${Y0 + r * CELL}" width="${CELL}" height="${CELL}" fill="${orange ? ORANGE_CLAIR : BLEU_CLAIR}" stroke="${orange ? ORANGE : BLEU}" stroke-width="1"/>`);
        }
    }
    return parts.join('\n  ');
};

const SVG_VOISIN = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 440 372" role="img"
     aria-label="Un rectangle de 7 lignes et 8 colonnes, découpé en un carré de 7 sur 7 en bleu et une colonne de 7 en orange. 7 fois 8, c'est 7 fois 7 plus 7, soit 49 plus 7 égale 56. Si je ne me souviens pas, je pars d'un produit voisin que je connais et j'ajoute ou j'enlève une fois le nombre. Pour un trou, je récite la table jusqu'à tomber sur le résultat : 7, 14, 21, jusqu'à 56, c'est 7 fois 8.">
  <text x="220" y="28" font-size="22" font-weight="bold" text-anchor="middle" fill="${ENCRE}">7 × 8 = ?</text>
  ${grille()}
  <text x="${X0 - 14}" y="${Y0 + 3.5 * CELL + 7}" font-size="18" font-weight="bold" text-anchor="middle" fill="${ENCRE}">7</text>
  <text x="${X0 + 3.5 * CELL}" y="${Y0 + 7 * CELL + 22}" font-size="18" font-weight="bold" text-anchor="middle" fill="${BLEU}">7</text>
  <text x="${X0 + 7.5 * CELL}" y="${Y0 + 7 * CELL + 22}" font-size="18" font-weight="bold" text-anchor="middle" fill="${ORANGE}">1</text>
  <text x="${X0 + 3.5 * CELL}" y="${Y0 + 3.5 * CELL + 8}" font-size="22" font-weight="bold" text-anchor="middle" fill="${BLEU}">7 × 7</text>
  <text x="220" y="${Y0 + 7 * CELL + 58}" font-size="22" font-weight="bold" text-anchor="middle" fill="${ENCRE}">7 × 8 = <tspan fill="${BLEU}">7 × 7</tspan> + <tspan fill="${ORANGE}">7</tspan> = <tspan fill="${BLEU}">49</tspan> + <tspan fill="${ORANGE}">7</tspan> = 56</text>
  <text x="220" y="${Y0 + 7 * CELL + 94}" font-size="14" text-anchor="middle" fill="${ENCRE}">Si je ne me souviens pas, je pars d'un produit voisin que je connais</text>
  <text x="220" y="${Y0 + 7 * CELL + 114}" font-size="14" text-anchor="middle" fill="${ENCRE}">et j'ajoute ou j'enlève <tspan font-weight="bold">une fois le nombre</tspan>.</text>
  <text x="220" y="${Y0 + 7 * CELL + 142}" font-size="14" text-anchor="middle" fill="${ENCRE}">Pour un trou, je récite la table jusqu'à tomber sur le résultat :</text>
  <text x="220" y="${Y0 + 7 * CELL + 162}" font-size="14" text-anchor="middle" fill="${ENCRE}">7, 14, 21, … 56, c'est <tspan font-weight="bold">7 × 8</tspan>.</text>
</svg>`.trim();

const AIDE = {
    pages: [
        { titre: 'Partir d\'un voisin', svg: SVG_VOISIN },
    ],
};

const CP_1047 = {
    flash_texte_trou_saisie: AIDE,
    sens_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
    sens_relier: AIDE,
};

export default CP_1047;
